import { render, staticRenderFns } from "./FormularioDocumento.vue?vue&type=template&id=64df0320"
import script from "./FormularioDocumento.vue?vue&type=script&lang=js"
export * from "./FormularioDocumento.vue?vue&type=script&lang=js"
import style0 from "./FormularioDocumento.vue?vue&type=style&index=0&id=64df0320&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports